import { Component, inject } from '@angular/core';
import { Toaster, ToastModel } from '../../services/toaster';
import { IconComponent } from '@kinomap-dev/ng-ui-lib/basics';
import { ColorService } from '../../services/color.service';

@Component({
  selector: 'app-toast',
  imports: [IconComponent],
  template: `
    @for (toast of toasterService.toasts(); track toast.id) {
      <div
        class="toast"
        [style.--duration]="toast.duration + 'ms'"
        [class]="toast.type"
        [animate.enter]="'toast-enter'"
        [animate.leave]="'toast-leave'"
      >
        @if (toast.icon) {
          <kin-icon [name]="toast.icon" [color]="colorService.backgroundColor()" />
        }
        @if (toast.title) {
          <p class="title">{{ getTitle(toast) }}</p>
        }
        <p class="message">{{ toast.msg }}</p>
        <kin-icon
          class="close-btn"
          [color]="colorService.backgroundColor()"
          name="close"
          [size]="24"
          (iconClick)="toasterService.remove(toast.id)"
        />
        <div class="toast-loader" [style.width.%]="100"></div>
      </div>
    }
  `,
  styleUrl: './toast.scss',
})
export class Toast {
  public toasterService: Toaster = inject(Toaster);
  readonly colorService: ColorService = inject(ColorService);

  getTitle(toast: ToastModel): string {
    switch (toast.type) {
      case 'success':
        return (toast.title = toast.title ? toast.title : 'Success');
      case 'error':
        return (toast.title = toast.title ? toast.title : 'Error');
      case 'info':
        return (toast.title = toast.title ? toast.title : 'Info');
      case 'warning':
        return (toast.title = toast.title ? toast.title : 'Warning');
      default:
        return (toast.title = '');
    }
  }
}
